import template from './swag-migration-dashboard-card.html.twig';
import './swag-migration-dashboard-card.scss';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-dashboard-card', {
    template,
});
